/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ServiceDocumentRevisionAdminDto = {
  /**
   * 리비전 ID
   */
  id: string;
  /**
   * 문서 타입
   */
  type: ServiceDocumentRevisionAdminDto.type;
  /**
   * 상태 (draft=초안, published=배포됨)
   */
  status: ServiceDocumentRevisionAdminDto.status;
  /**
   * 배포 시 확정되는 버전 (초안은 null)
   */
  version?: Record<string, any> | null;
  /**
   * 마크다운 본문 — 목록 조회에서는 생략
   */
  content?: string;
  /**
   * 마지막 수정/배포 어드민 이메일
   */
  updatedByAdminEmail?: Record<string, any> | null;
  /**
   * 배포 시각 (초안은 null)
   */
  publishedAt?: Record<string, any> | null;
  /**
   * 생성 시각
   */
  createdAt: string;
  /**
   * 마지막 수정 시각
   */
  updatedAt: string;
};
export namespace ServiceDocumentRevisionAdminDto {
  /**
   * 문서 타입
   */
  export enum type {
    TERMS = "terms",
    PRIVACY = "privacy",
    MARKETING = "marketing",
  }
  /**
   * 상태 (draft=초안, published=배포됨)
   */
  export enum status {
    DRAFT = "draft",
    PUBLISHED = "published",
  }
}
